export enum SoortOpnamesUitkering {
  Eenmalig,
  Periodiek
}
